import { render } from "./FreeSpaceModal.vue?vue&type=template&id=60a91ac4&scoped=true&ts=true"
import script from "./FreeSpaceModal.vue?vue&type=script&lang=ts"
export * from "./FreeSpaceModal.vue?vue&type=script&lang=ts"

import "./FreeSpaceModal.vue?vue&type=style&index=0&id=60a91ac4&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a91ac4"]])

export default __exports__